module.exports = __webpack_public_path__ + "img/SKMJ_crain4.fb7c951d.jpg";